/**
 * Bank account strings (operating / trust / escrow accounts).
 *
 * Shared by the Accounts and Payment-Processor account editors. Help text (h_)
 * was migrated from the inline renderHelpLabel JSX in
 * src/Configuration/Accounts/AccountCard.tsx and
 * src/Configuration/PaymentProcessors/ProcessorAccountCard.tsx — verify against
 * the implementation.
 */
export default {
    d_accountType: 'Type',
    h_accountType: "<div>There are three types of accounts: operating, trust and escrow.</div><div><b>Operating</b> accounts are <i>your firm's</i> (earned) money.</div><div><b>Trust</b> (or <b>IOLTA</b>) accounts are <i>your clients'</i> (unearned) money.</div><div><b>Escrow</b> accounts hold funds in escrow, e.g. proceeds from a property sale.</div><br/><div>Note that only one Trust/IOLTA account is supported.</div>",

    d_matterId: 'Case',
    h_matterId: 'Which case is this escrow account related to?',
};
